import React from "react";

const Footer = () => {
    return (
        <div className="header-container">
            <p className="mb-1 text-muted">
                © 2025 Symmatics | Powered by <strong>
                <a target="_blank" className="text-muted link-undecorated" href="https://www.payhere.lk">Payhere</a>
            </strong>
            </p>
            <p>
                <a href="https://symmatics.com/terms-of-service" className="text-muted">Terms</a>&nbsp;
                <a href="https://symmatics.com/privacy-policy" className="text-muted">Privacy</a>&nbsp;
                <a href="https://symmatics.com/contact" className="text-muted">Contact</a>
            </p>
        </div>
    );
};

export default Footer;
